import { connect } from 'react-redux';
import { RootState } from '../../../state';
import UserPage, { Props } from './UserPage';
import {
  findUsersByCustomerId,
  updateUser,
  deleteUser,
  removeFromSite,
  createUser,
  resendInvite,
  getUsersWithSiteAccess,
} from '../../../state/entities';
import { getSiteContext } from '../../../state/contexts/site';
import { getProfileContext } from '../../../state/contexts/auth/selectors';
import { clearRequest } from '../../../state/request/actions';

const mapStateToProps = (rootState: RootState): Props => {
  const { id: siteId, customerId } = getSiteContext(rootState);
  // userCustomerId is the customerId of the logged-in user
  const { customerId: userCustomerId } = getProfileContext(rootState);
  const profile = getProfileContext(rootState);
  const allSiteCustomerUsers = findUsersByCustomerId(rootState, customerId);
  // allUserCustomerUsers are users linked to the customer of the logged-in user
  const allUserCustomerUsers = findUsersByCustomerId(rootState, userCustomerId);

  const assignedSiteCustomerUsers = getUsersWithSiteAccess(rootState, siteId, customerId);
  const assignedUserCustomerUsers = getUsersWithSiteAccess(rootState, siteId, userCustomerId);

  const allUsers = [...allSiteCustomerUsers, ...allUserCustomerUsers].filter(
    (user, index, self) => self.findIndex((u) => u.userId === user.userId) === index
  );

  const assignedUsers = [...assignedSiteCustomerUsers, ...assignedUserCustomerUsers].filter(
    (user, index, self) => self.findIndex((u) => u.userId === user.userId) === index
  );

  return {
    profile,
    siteId,
    customerId,
    /**
     * Users that are linked to this customer
     */
    allUsers,
    /**
     * Users assigned to this site and linked to this customer, as well as users linked to the customer of
     * the logged-in user.
     * Note: currently excludes users who are assigned to this site, but part
     *       of a different customer.
     */
    assignedUsers,
  };
};

const actions = {
  updateUser: updateUser.request,
  deleteUser: deleteUser.request,
  removeFromSite: removeFromSite.request,
  createNewUser: createUser.request,
  resendInvite: resendInvite.request,
  clearError: clearRequest,
};

export default connect(mapStateToProps, actions)(UserPage);
